export enum ReservationStartTimeType {
  CanStartAtWholeOrHalfHour = 1,
  CanStartAtWholeHourOnly = 2,
  CanStartAtHalfHourOnly = 3
}